module.exports = __webpack_public_path__ + "img/badge_standard.7e077f19.png";